// Whiteboard relay message types.
// KEEP IN SYNC with realtime/src/protocol.js and the copy in
// dashboard/src/pages/LiveWhiteboard/wsProtocol.js (teacher app).

export const WS_TYPES = {
    // client -> server
    HELLO: 'hello',
    DRAW_OPS: 'draw:ops',
    DRAW_UNDO: 'draw:undo',
    DRAW_CLEAR: 'draw:clear',
    PERM_DRAW: 'perm:draw',
    PDF_OPEN: 'pdf:open',
    PDF_PAGE: 'pdf:page',
    POINTER: 'pointer',
    Q_PUSH: 'q:push',
    Q_ANSWER: 'q:answer',
    Q_CLOSE: 'q:close',
    GRADE: 'grade',
    STAR_AWARD: 'star:award',
    SESSION_END: 'session:end',
    TIMER_START: 'timer:start',
    TIMER_STOP: 'timer:stop',
    CAL_SHOW: 'calendar:show',
    CAL_HIDE: 'calendar:hide',
    BG_SET: 'bg:set',
    WHEEL_SPIN: 'wheel:spin',
    HAND_RAISE: 'hand:raise',
    HAND_LOWER: 'hand:lower',
    ACT_START: 'activity:start',
    ACT_VOTE: 'activity:vote',
    ACT_STOP: 'activity:stop',
    Q_REVEAL: 'q:reveal',
    Q_REVEAL_HIDE: 'q:reveal:hide',
    YT_OPEN: 'yt:open',
    YT_STATE: 'yt:state',
    YT_CLOSE: 'yt:close',
    FILE_SHARE: 'file:share',
    FILE_SUBMIT: 'file:submit',
    SQ_ASK: 'sq:ask',
    SQ_DONE: 'sq:done',
    SQ_SHOW: 'sq:show',
    SQ_HIDE: 'sq:hide',
    CURTAIN: 'curtain',
    BADGE_AWARD: 'badge:award',
    NOTE_SET: 'note:set',

    // server -> client
    SNAPSHOT: 'snapshot',
    PARTICIPANT_JOIN: 'participant:join',
    PARTICIPANT_LEAVE: 'participant:leave',
    Q_PUSHED: 'q:pushed',
    Q_CLOSED: 'q:closed',
    Q_ANSWERED: 'q:answered',
    Q_ACK: 'q:ack',
    GRADED: 'graded',
    STAR_AWARDED: 'star:awarded',
    LEADERBOARD: 'leaderboard',
    TEACHER_ONLINE: 'teacher:online',
    TEACHER_OFFLINE: 'teacher:offline',
    SESSION_RESULTS: 'session:results',
    SESSION_CHECKPOINT: 'session:checkpoint',
    SESSION_ENDED: 'session:ended',
    TIMER_UPDATE: 'timer:update',
    CAL_UPDATE: 'calendar:update',
    HAND_UPDATE: 'hand:update',
    ACT_UPDATE: 'activity:update',
    ACT_ACK: 'activity:ack',
    REVEAL_UPDATE: 'reveal:update',
    YT_UPDATE: 'yt:update',
    FILES_UPDATE: 'files:update',
    INBOX_UPDATE: 'inbox:update',
    SQ_SHOWN: 'sq:shown',
    BADGE_AWARDED: 'badge:awarded',
    NOTE_UPDATE: 'note:update',
    ERROR: 'error',
};

// pulls the video id out of any usual YouTube URL shape
export const extractYouTubeId = (url) => {
    const match = String(url || '').match(
        /(?:youtube\.com\/(?:watch\?.*v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,20})/
    );
    return match ? match[1] : null;
};

export const BOARD_BACKGROUNDS = ['white', 'black', 'grid', 'lines'];

export const MAIN_BOARD = 'main';

// lesson-plan notes the teacher can show the class; order matters, it is the
// order the popup renders them in
export const NOTE_KINDS = ['goals', 'identity'];

// short stable key per document URL so each shared file gets its own
// annotation boards (pdf:<docKey>:<page>)
const docKey = (url) => {
    const value = String(url || '');
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = (hash * 31 + value.charCodeAt(i)) | 0;
    }
    return (hash >>> 0).toString(36);
};

export const pdfBoardId = (url, page) => `pdf:${docKey(url)}:${page}`;

let opCounter = 0;
export const newOpId = () =>
    `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}-${opCounter++}`;
